import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AboutComponent } from './core/components/about/about.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';

declare var require: any;


const appRoutes: Routes = [ 
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    //{ path: '', component: AboutComponent },
    { path: 'login', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./login/login.module')['LoginModule']);  });}) },
    { path: 'rastreamento', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./tracker/tracker.module')['TrackerModule']);  });}) },
    { path: 'entregas', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./delivery/delivery.module')['DeliveryModule']);  });}) },
    { path: 'visitas', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./visit/visit.module')['VisitModule']);  });}) },
    { path: 'cadastros', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./cadastral/cadastral.module')['CadastralModule']);  });}) },
    { path: 'relatorios', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./report/report.module')['ReportModule']);  });}) },
    { path: 'notificacoes', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./notification/notification.module')['NotificationModule']);  });}) },
    { path: '**', redirectTo: 'rastreamento', pathMatch: 'full' }//component: PageNotFoundComponent }
]

@NgModule({
    imports: [ RouterModule.forRoot(appRoutes) ],
    exports: [ RouterModule ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/app.routing.module.ts